var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEurex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533.12,
    height: 182.16,
    viewBox: "0 0 533.12 182.16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,182.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1338.96,1335.62 430.48,-429.218 c 40.27,-40.172 39.18,-105.16 -0.94,-145.781 -40.12,-40.168 -105.3,-40.168 -145.55,0 l -0.27,-0.449 -430.48,429.218 c -40.27,40.16 -39.18,105.61 0.94,145.78 40.12,40.16 105.57,40.62 145.82,0.45",
    style: {
      fill: "#6fc72d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1338.96,30.8203 430.48,429.2147 c 40.27,40.164 39.18,105.156 -0.94,145.32 -40.12,40.625 -105.3,40.625 -145.55,0.45 h -0.27 L 1192.2,176.602 c -40.27,-40.172 -39.18,-105.1606 0.94,-145.3325 40.12,-40.16794 105.57,-40.62106 145.82,-0.4492",
    style: {
      fill: "#6fc72d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2490.72,1189.84 2061.46,759.27 c -40.12,-40.172 -105.39,-39.27 -145.65,0.902 -40.25,40.164 -40.34,105.609 -0.22,145.777 h -0.27 l 429.3,430.571 c 40.13,40.17 105.34,39.27 145.6,-0.9 40.26,-40.17 40.67,-105.62 0.5,-145.78",
    style: {
      fill: "#213462",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2490.72,176.602 -429.26,430.562 c -40.12,40.164 -105.39,38.816 -145.65,-1.359 -40.25,-40.164 -40.34,-105.157 -0.22,-145.321 l -0.27,-0.449 429.3,-430.5741 c 40.13,-40.1718 105.34,-38.81246 145.6,1.3594 40.26,39.711 40.67,105.1487 0.5,145.7817",
    style: {
      fill: "#213462",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 0,1346.45 h 759.688 c 60.566,0 109.667,-45.13 109.667,-100.65 0,-55.06 -49.101,-100.19 -109.667,-100.19 H 218.633 V 227.141 h 541.055 c 60.566,0 109.667,-45.129 109.667,-100.641 0,-55.5195 -49.101,-100.1992 -109.667,-100.1992 L 0,26.3008 V 1346.45",
    style: {
      fill: "#213462",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1467.46,689.313 c 0,55.058 -47.62,99.742 -106.33,99.742 v 0 H 428.496 V 589.566 h 932.634 v 0 c 0.04,0 0.04,0 0.09,0 h 0.63 v 0 c 58.4,0.45 105.61,44.676 105.61,99.747",
    style: {
      fill: "#213462",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3998.44,771.898 -41.98,23.473 -55.5,-69.058 -55.53,69.058 -41.97,-23.473 66.8,-83.488 -66.8,-83.953 43.33,-21.211 54.17,67.246 54.16,-67.246 43.32,21.211 -67.25,83.953 67.25,83.488",
    style: {
      fill: "#213462",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2611.49,683.441 c 0,69.055 -29.15,110.579 -91.88,110.579 -64.91,0 -101.51,-52.805 -101.51,-105.61 0,-62.293 40.57,-104.265 97.09,-104.265 36.23,0 67.15,15.8 90.57,39.269 l -30.91,25.274 c -13.72,-13.086 -30.51,-25.723 -51.72,-25.723 -37.1,0 -50.78,32.937 -51.23,60.476 h 139.59 m -136.92,33.848 c 2.2,19.406 20.74,42.883 45.04,42.883 28.29,0 39.31,-21.664 40.66,-42.883 h -85.7",
    style: {
      fill: "#213462",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2979.78,589.566 h -53.71 v 24.375 h -0.89 c -16.71,-17.609 -41.98,-29.796 -69.07,-29.796 -49.2,0 -61.82,28.886 -61.82,67.707 0,12.187 0.44,24.371 0.44,37.007 l 1.35,99.739 h 53.71 l -0.44,-49.645 c -0.45,-28.879 -0.91,-56.867 -0.91,-78.539 0,-23.008 6.77,-32.488 29.33,-32.488 16.71,0 35.67,13.992 49.2,25.73 l 0.9,134.942 h 53.71 l -1.8,-199.032",
    style: {
      fill: "#213462",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3185.14,788.598 h 53.71 v -36.559 l 0.45,-0.441 c 10.38,22.562 24.36,41.519 51.45,42.422 5.41,0 10.83,-0.903 16.24,-1.801 l -9.02,-46.492 c -4.5,0.898 -8.58,1.804 -12.64,1.804 -20.76,0 -36.1,-13.992 -46.93,-34.754 l -1.36,-123.211 h -54.16 l 2.26,199.032",
    style: {
      fill: "#213462",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3644.6,683.441 c 0,69.055 -29.34,110.579 -92.08,110.579 -64.54,0 -101.09,-52.805 -101.09,-105.61 0,-62.293 40.16,-104.265 97.03,-104.265 36.11,0 66.8,15.8 90.27,39.269 l -30.69,25.274 c -14,-13.086 -30.69,-25.723 -51.91,-25.723 -37.01,0 -50.54,32.937 -50.99,60.476 h 139.46 m -136.77,33.848 c 2.27,19.406 20.76,42.883 44.69,42.883 28.44,0 39.27,-21.664 40.62,-42.883 h -85.31",
    style: {
      fill: "#213462",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEurex);
export default __webpack_public_path__ + "static/media/eurex.a8e9e01c007445e29d272858e660e5b4.svg";
export { ForwardRef as ReactComponent };